import React, { ForwardedRef, forwardRef } from 'react';

import { Field, FieldProps } from '@reckon-web/field';
import { SelectInput, SelectInputProps } from '@reckon-web/select-input';

export type SelectFieldProps<Value extends string | number> =
  SelectInputProps<Value> & FieldProps;

const SelectFieldInner = <Value extends string | number>(
  {
    description,
    helpText,
    id,
    invalidMessage,
    label,
    labelVisible,
    reserveMessageSpace,
    ...inputProps
  }: SelectFieldProps<Value>,
  inputRef: ForwardedRef<HTMLSelectElement> | undefined
) => {
  return (
    <Field
      description={description}
      helpText={helpText}
      id={id}
      invalidMessage={invalidMessage}
      label={label}
      labelVisible={labelVisible}
      reserveMessageSpace={reserveMessageSpace}
    >
      <SelectInput {...inputProps} ref={inputRef} />
    </Field>
  );
};

export const SelectField = forwardRef(SelectFieldInner) as <
  Value extends string | number,
>(
  props: SelectFieldProps<Value> & {
    ref?: ForwardedRef<HTMLSelectElement>;
  }
) => ReturnType<typeof SelectFieldInner>;
